export const createReducer = (initialState, handlers) => {
    return (state = initialState, action) => {
        // // console.log('DEBUG 1 REDUCER CALLED')
        const handler = handlers[action.type]
        return handler ? handler(state, action) : state
    }
}

export default {
    createReducer
}


// WEBPACK FOOTER //
// ./src/utils/ReduxUtils.js